import { render, staticRenderFns } from "./SchoolFront.vue?vue&type=template&id=6e03da47&"
import script from "./SchoolFront.vue?vue&type=script&lang=js&"
export * from "./SchoolFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports